import script from "./CustomEmailsQuery.vue?vue&type=script&lang=js"
export * from "./CustomEmailsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__